import BaseModel from "./base/baseModel";

export default class InformacoesAdicionaisRepresentanteModel extends BaseModel {
    tipoCadastro = 1;
    registroId: number;
    texto = "";
    usuarioCriacaoNome = "";
    dataCriacao: Date;
}
